import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TermsofuseComponent } from './termsofuse/termsofuse.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { CookiesComponent } from './cookies/cookies.component';
import { TicketpolicyComponent } from './ticketpolicy/ticketpolicy.component';
import { CodeofconductComponent } from './codeofconduct/codeofconduct.component';

const routes: Routes = [
  {path: "terms-of-use", component: TermsofuseComponent},
  {path: "privacy", component: PrivacyComponent},
  {path: "cookies", component: CookiesComponent},
  {path: "ticket-policy", component: TicketpolicyComponent},
  {path: "code_of_conduct", component: CodeofconductComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrivacyRoutingModule { }
